import React, { useState } from 'react';
import { Search, HelpCircle, AlertCircle, PlayCircle, Settings, ChevronLeft, ChevronRight, Home, BarChart2, Edit2, PauseCircle, ChevronDown, Filter, Trash2, Globe, Calendar, User } from 'lucide-react';

const Automation = () => {
    const [view, setView] = useState('list'); // 'list' or 'detail'

    const handleOpenDetail = () => {
        setView('detail');
    };

    const handleBackToList = () => {
        setView('list');
    };

    return (
        <div style={ { padding: '0', marginTop: '-24px', marginBottom: '-24px', fontFamily: '"Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif', background: '#f9fafb', minHeight: '85vh' } }>
            { view === 'list' ? (
                <ListView onOpenDetail={ handleOpenDetail } />
            ) : (
                <DetailView onBack={ handleBackToList } />
            ) }
        </div>
    );
};

// --- LIST VIEW COMPONENT ---
const ListView = ({ onOpenDetail }) => {
    return (
        <div style={ { background: '#fff', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', minHeight: '600px', display: 'flex', flexDirection: 'column' } }>
            {/* Header */ }
            <div style={ { padding: '10px 24px', borderBottom: '1px solid #f3f4f6' } }>
                <div style={ { display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' } }>
                    <h2 style={ { margin: 0, fontSize: '20px', fontWeight: 600, color: '#374151' } }>Automation</h2>
                    <HelpCircle size={ 18 } color="#9ca3af" style={ { cursor: 'pointer' } } />
                    <PlayCircle size={ 18 } color="#9ca3af" style={ { cursor: 'pointer' } } />
                    <AlertCircle size={ 18 } color="#9ca3af" style={ { cursor: 'pointer' } } />
                </div>

                <div style={ { display: 'flex', alignItems: 'center', gap: '15px' } }>
                    <div style={ { position: 'relative', width: '250px' } }>
                        <input
                            type="text"
                            placeholder="Search Automation"
                            style={ {
                                width: '100%',
                                padding: '8px 30px 8px 10px',
                                border: '1px solid #d1d5db',
                                borderRadius: '4px',
                                fontSize: '14px',
                                outline: 'none'
                            } }
                        />
                        <Search size={ 16 } color="#9ca3af" style={ { position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' } } />
                    </div>
                </div>

                <div style={ { marginTop: '15px', display: 'flex', alignItems: 'center', gap: '10px' } }>
                    <span style={ { fontWeight: 'bold', color: '#dc2626', fontSize: '14px', background: '#fee2e2', padding: '2px 8px', borderRadius: '4px' } }>1</span>
                    <span style={ { fontSize: '14px', color: '#4b5563' } }>results found</span>
                    <div style={ { display: 'flex', alignItems: 'center', background: '#374151', color: '#fff', padding: '2px 8px', borderRadius: '4px', fontSize: '12px', gap: '6px' } }>
                        SEP <span style={ { cursor: 'pointer' } }>×</span>
                    </div>
                </div>
            </div>

            {/* Filters Bar */ }
            <div style={ { background: '#f3f4f6', padding: '10px 24px', borderBottom: '1px solid #e5e7eb', display: 'flex', gap: '15px', alignItems: 'center', fontSize: '13px', color: '#4b5563' } }>
                { ['Trigger Type', 'Status', 'Modified By', 'Scope', 'Modified On'].map((filter, i) => (
                    <div key={ i } style={ { display: 'flex', flexDirection: 'column', gap: '2px' } }>
                        <span style={ { fontWeight: 600 } }>{ filter }</span>
                        <div style={ { background: '#fff', border: '1px solid #d1d5db', borderRadius: '4px', padding: '4px 8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100px', cursor: 'pointer' } }>
                            All <ChevronDown size={ 12 } />
                        </div>
                    </div>
                )) }
                <div style={ { marginLeft: 'auto', cursor: 'pointer' } }>
                    <Filter size={ 18 } color="#6b7280" />
                </div>
            </div>

            {/* Table */ }
            <div style={ { flex: 1 } }>
                <table style={ { width: '100%', borderCollapse: 'collapse', fontSize: '13px' } }>
                    <thead>
                        <tr style={ { background: '#f9fafb', borderBottom: '1px solid #e5e7eb', color: '#6b7280', textAlign: 'left' } }>
                            <th style={ { padding: '12px 24px', fontWeight: 600 } }>Name</th>
                            <th style={ { padding: '12px', fontWeight: 600 } }>Trigger Type</th>
                            <th style={ { padding: '12px', fontWeight: 600 } }>Scope</th>
                            <th style={ { padding: '12px', fontWeight: 600 } }>Trigger Count</th>
                            <th style={ { padding: '12px', fontWeight: 600 } }>Last Published On</th>
                            <th style={ { padding: '12px', fontWeight: 600 } }>Status</th>
                            <th style={ { padding: '12px', fontWeight: 600 } }>Modified On ↓</th>
                            <th style={ { padding: '12px', fontWeight: 600 } }>Modified By</th>
                            <th style={ { padding: '12px', fontWeight: 600 } }>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style={ { background: '#fff5eb', borderBottom: '1px solid #fed7aa' } }>
                            <td style={ { padding: '12px 24px' } }>
                                <span
                                    onClick={ onOpenDetail }
                                    style={ { color: '#1f2937', fontWeight: 500, cursor: 'pointer', borderBottom: '1px dotted #374151' } }
                                >
                                    September_B2C automation
                                </span>
                            </td>
                            <td style={ { padding: '12px' } }>Lead Updated</td>
                            <td style={ { padding: '12px' } }>Global</td>
                            <td style={ { padding: '12px' } }>1723</td>
                            <td style={ { padding: '12px' } }>19/09/2025</td>
                            <td style={ { padding: '12px' } }>Published</td>
                            <td style={ { padding: '12px' } }>20/01/2026</td>
                            <td style={ { padding: '12px' } }>Marketing</td>
                            <td style={ { padding: '12px' } }><Settings size={ 16 } color="#9ca3af" style={ { cursor: 'pointer' } } /></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Pagination */ }
            <div style={ { padding: '16px 24px', borderTop: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'space-between' } }>
                <div style={ { display: 'flex', alignItems: 'center', gap: '10px', fontSize: '13px' } }>
                    <span>Show</span>
                    <select style={ { padding: '4px', borderRadius: '4px', border: '1px solid #d1d5db' } }><option>25</option></select>
                </div>

                <div style={ { display: 'flex', alignItems: 'center', gap: '15px' } }>
                    <span style={ { fontSize: '13px', fontWeight: 500 } }>1 - 1 of 1</span>
                    <div style={ { display: 'flex', gap: '5px' } }>
                        <button disabled style={ { padding: '6px 10px', border: '1px solid #e5e7eb', background: '#f3f4f6', borderRadius: '4px', cursor: 'not-allowed' } }><ChevronLeft size={ 14 } /></button>
                        <button style={ { padding: '6px 12px', border: 'none', background: '#374151', color: '#fff', borderRadius: '4px' } }>1</button>
                        <button disabled style={ { padding: '6px 10px', border: '1px solid #e5e7eb', background: '#f3f4f6', borderRadius: '4px', cursor: 'not-allowed' } }><ChevronRight size={ 14 } /></button>
                    </div>
                </div>
            </div>
        </div>
    );
};

// --- DETAIL FLOWCHART COMPONENT ---
const DetailView = ({ onBack }) => {
    return (
        <div style={ { display: 'flex', flexDirection: 'column', height: '100%' } }>
            {/* Top Toolbar */ }
            <div style={ { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px', background: '#fff', padding: '10px 20px', borderRadius: '8px', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' } }>
                <div style={ { display: 'flex', alignItems: 'center', gap: '15px' } }>
                    <button onClick={ onBack } style={ { border: '1px solid #d1d5db', background: '#fff', borderRadius: '4px', padding: '6px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' } }>
                        <Home size={ 18 } color="#4b5563" />
                    </button>
                    <div style={ { display: 'flex', alignItems: 'center', gap: '8px' } }>
                        <div style={ { width: '8px', height: '8px', borderRadius: '50%', background: '#22c55e' } }></div>
                        <span style={ { fontSize: '14px', fontWeight: 600, color: '#374151' } }>September_B2C automation (Published)</span>
                        <Edit2 size={ 14 } color="#9ca3af" style={ { cursor: 'pointer' } } />
                    </div>
                </div>

                <div style={ { display: 'flex', gap: '10px' } }>
                    <button style={ { display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 16px', background: '#fff', border: '1px solid #e5e7eb', borderRadius: '4px', fontSize: '13px', fontWeight: 500, color: '#374151', cursor: 'pointer' } }>
                        <BarChart2 size={ 14 } /> Reports
                    </button>
                    <button style={ { padding: '8px 16px', background: '#f97316', border: 'none', borderRadius: '4px', fontSize: '13px', fontWeight: 500, color: '#fff', cursor: 'pointer' } }>
                        Live Edit
                    </button>
                    <button style={ { padding: '8px 16px', background: '#3b82f6', border: 'none', borderRadius: '4px', fontSize: '13px', fontWeight: 500, color: '#fff', cursor: 'pointer' } }>
                        Unpublish
                    </button>
                </div>
            </div>

            {/* Canvas Area */ }
            <div style={ { flex: 1, position: 'relative', display: 'flex', justifyContent: 'center', padding: '40px 0', background: '#f4f5f7', borderRadius: '8px', minHeight: '600px', overflow: 'auto' } }>
                <div style={ { textAlign: 'center', color: '#6b7280', fontSize: '12px', marginBottom: '20px', position: 'absolute', top: '20px' } }>Your Automation starts here</div>

                <div style={ { display: 'flex', flexDirection: 'column', alignItems: 'center' } }>

                    {/* Node 1: Lead Update */ }
                    <div style={ { width: '300px', background: '#fff', borderRadius: '4px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb', textAlign: 'left', position: 'relative', zIndex: 10 } }>
                        <div style={ { padding: '15px' } }>
                            <div style={ { fontWeight: 600, fontSize: '14px', marginBottom: '4px' } }>Lead Update</div>
                            <div style={ { fontSize: '12px', color: '#6b7280' } }>When Lead field(s) changes</div>
                        </div>
                        {/* Bottom Bar: Green */ }
                        <div style={ { height: '4px', background: '#22c55e', borderRadius: '0 0 4px 4px' } }></div>
                    </div>

                    {/* Arrow 1 */ }
                    <div style={ { height: '40px', width: '2px', background: '#9ca3af', position: 'relative' } }>
                        <div style={ { position: 'absolute', bottom: '0', left: '-4px', width: '0', height: '0', borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderTop: '6px solid #9ca3af' } }></div>
                        <span style={ { position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', fontSize: '10px', color: '#6b7280' } }>Event1</span>
                    </div>

                    {/* Node 2: If/Else */ }
                    <div style={ { width: '300px', background: '#fff', borderRadius: '4px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb', textAlign: 'left', position: 'relative', zIndex: 10 } }>
                        <div style={ { padding: '15px' } }>
                            <div style={ { fontWeight: 600, fontSize: '14px', marginBottom: '4px' } }>If/Else</div>
                            <div style={ { fontSize: '12px', color: '#6b7280' } }>Campaign ID contains...</div>
                        </div>
                        {/* Bottom Bar: Split Green/Red */ }
                        <div style={ { display: 'flex', height: '4px', borderRadius: '0 0 4px 4px', overflow: 'hidden' } }>
                            <div style={ { width: '50%', background: '#22c55e' } }></div>
                            <div style={ { width: '50%', background: '#ef4444' } }></div>
                        </div>
                    </div>

                    {/* Arrow 2 (Yes Path) */ }
                    <div style={ { height: '40px', width: '2px', background: '#22c55e', position: 'relative', alignSelf: 'center', marginLeft: '-150px' /* Offset to align with left splits */ } }>
                        <div style={ { position: 'absolute', bottom: '0', left: '-4px', width: '0', height: '0', borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderTop: '6px solid #22c55e' } }></div>
                        <span style={ { position: 'absolute', left: '-25px', top: '10px', fontSize: '10px', color: '#6b7280' } }>IfElse2</span>
                        <span style={ { position: 'absolute', bottom: '5px', right: '8px', fontSize: '11px', fontWeight: 600, color: '#22c55e' } }>Yes</span>
                        {/* Connecting line geometry tricky without SVG, simplifying to straight drop for now */ }
                    </div>

                    {/* Fix Alignment for branching visual: Moving geometry manually */ }
                    <div style={ {
                        position: 'relative', height: '40px', width: '300px', display: 'flex'
                    } }>
                        {/* Yes branch */ }
                        <div style={ { flex: 1, borderRight: '2px solid #22c55e', height: '40px', marginTop: '-40px', transform: 'skewX(0deg)' } }></div>
                        {/* Just using the previous vertical div for visual simplicity as pure CSS tree is hard. 
                            Let's just place the next node under the yes path visually by offsetting container
                        */}
                    </div>

                    {/* Node 3: Create Task (Yes Branch) */ }
                    <div style={ { width: '300px', background: '#fff', borderRadius: '4px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb', textAlign: 'left', position: 'relative', alignSelf: 'center', marginLeft: '-150px', marginTop: '-40px' } }>
                        <div style={ { padding: '15px', position: 'relative' } }>
                            <div style={ { fontWeight: 600, fontSize: '14px', marginBottom: '4px' } }>Create Task</div>
                            <div style={ { fontSize: '12px', color: '#6b7280' } }>Follow Up: @(Lead.FirstName)...</div>
                            <HelpCircle size={ 14 } color="#9ca3af" style={ { position: 'absolute', top: '15px', right: '15px' } } />
                        </div>
                        {/* Bottom Bar: Blue */ }
                        <div style={ { height: '4px', background: '#3b82f6', borderRadius: '0 0 4px 4px' } }></div>
                    </div>
                    <div style={ { fontSize: '10px', color: '#6b7280', alignSelf: 'flex-start', marginLeft: '75px', marginTop: '4px' } }>Create Task3</div>

                </div>
            </div>
        </div>
    );
};

export default Automation;
